<template>
  <div
    class="modal fade"
    :class="{ in: isShowModal, active: isShow, 'is-scroll': isScroll }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-show="isShow"
  >
    <div class="modal-bg" @click="onModalClose"></div>
    <template v-if="type==='custom'">
      <div class="modal-dialog is-custom" :style="modalDialogStyle">
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <div class="modal-dialog" :style="modalDialogStyle">
        <div class="modal-content">
          <div
              class="common-modal-close"
              data-dismiss="modal"
              aria-label="Close"
              v-show="!disableClose"
              @click="close"
          >
            <img
                class="common-modal-close"
                src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
            />
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "CommonModal",
  props: {
    isShow: {
      type: Boolean,
    },
    isScroll: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disableClose: {
      type: Boolean,
      default() {
        return false;
      },
    },
    modalWidth: {
      type: Number,
      default() {
        return 590;
      },
    },
    isClose: {
      type: Boolean,
      default() {
        return false;
      }
    },
    closeOnClickModal: {
      type: Boolean,
      default() {
        return true;
      }
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      isShowModal: false,
    };
  },
  beforeMount() {
    if (this.isShow) {
      setTimeout(() => {
        this.isShowModal = true;
      }, 100);
    }
  },
  methods: {
    onModalClose() {
      if (this.disableClose || this.closeOnClickModal) return;

      this.isShowModal = false;
      setTimeout(() => {
        this.$emit("onModalClose");
      }, 100);
    },
    close() {
      this.isShowModal = false;
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    }
  },
  computed: {
    modalDialogStyle() {
      return { width: this.modalWidth + "px" };
    },
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.modal.active {
  display: block;
}
.modal.is-scroll {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal {
  .modal-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin: 0px auto;
  }
  .common-modal-close {
    position: absolute;
    width: 28px;
    top: 4px;
    right: 4px;
    z-index: 2;
    cursor: pointer;
  }
}
</style>